import DeviceCheck from '@/assets/DeviceCheck.js'

var TGPS = new function() {
	this.coords = {};
	this.acc;
	this.onSuc = false;
	this.onErr = false;
	this.getLooping = false;
	this.getLoopTime;
	this.watchID = false;

	this.set = function(s) {
		this.maxAge = s.maximumAge || 10000;
		this.timeout = s.timeout || 15000;
		this.onSuc = s.onSuccess;
		this.onErr = s.onError || false;
		return this;
	};

	this.get = function() {
		return this.coords;
	};

	this.try = function(suc, err) {
		suc = suc || function(){};
		err = err || function(){};

		navigator.geolocation.getCurrentPosition(suc, err, {
		  enableHighAccuracy: true,
		  maximumAge: 0,
		  timeout: 1
		});
	};

	this.getString = function() {
		return this.coords.lat + ',' + this.coords.lng;
	};

	this.watch = function() {
		this.watchID = navigator.geolocation.watchPosition(TGPS.suc, TGPS.err, {enableHighAccuracy: true, maximumAge: TGPS.maxAge, timeout: TGPS.timeout});
		return this.watchID;
	};

	this.clearWatch = function() {
		var that = this;
		navigator.geolocation.clearWatch(that.watchID);
		this.watchID = false;
	};

	this.stopLooping = function() {
		this.getLooping = false;
	};

	this.takeOver = function(suc) {
		this.onSuc = suc;
	};

	this.getPos = function(s) {
		if(s != undefined) {

			if(s.loop != undefined) {
				this.getLooping = true;
				this.getLoopTime = s.loop;
			}
		}

		TGPS.getCurrPos();

		return this;
	};

	this.getCurrPos = function() {
		navigator.geolocation.getCurrentPosition(TGPS.suc, TGPS.err, {enableHighAccuracy: true, maximumAge: TGPS.maxAge, timeout: TGPS.timeout});
		return this;
	};

	this.suc = function(pos) {
		TGPS.coords.lat = pos.coords.latitude;
		TGPS.coords.lng = pos.coords.longitude;
		TGPS.acc = pos.coords.accuracy;
		if(TGPS.onSuc) {
			TGPS.onSuc();
		}

		if(TGPS.getLooping) {
			setTimeout(TGPS.getPos, TGPS.getLoopTime);
		}
	};

	this.err = function(error) {
		if(TGPS.onErr != false) {
			TGPS.onErr(error);
		}
	};
};

export default TGPS;
